<script setup>
import KpiTable from "./kpiTable.vue";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import MultiSelectComponent from "@/components/MultiSelectComponent.vue";
import useKpiSection from "@/scripts/Courses/Kpi/kpiSection";

const { courses, loading, generateReport, primaryCourses, generateDisabled } =
  useKpiSection();
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="card pt-3 pl-1 pr-1">
        <div class="col-4">
          <MultiSelectComponent
            v-model="courses"
            :options="primaryCourses"
            label="name"
            track-by="id"
            placeholder="Select Course"
          />
        </div>
        <div class="pt-3 pb-4 pl-2">
          <div class="row">
            <div class="col-12 col-md-4">
              <input
                type="text"
                placeholder="Date"
                id="datepicker"
                class="form-control"
              />
            </div>
            <div class="col-12 col-md-2 mt-2 mt-md-0">
              <button
                @click="generateReport"
                class="btn btn-primary fixed-width-button"
                :disabled="loading || generateDisabled"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">Generate Report</span>
              </button>
            </div>
          </div>
        </div>
        <KpiTable />
      </div>
    </div>
  </section>
</template>

<style scoped>
.fixed-width-button {
  width: 150px;
}
</style>
